import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../App.css";
import "./PrevMatches.css";
import axios from "axios";
import {
  getMyChoice,
  getOtherChoice,
  getFirstName,
  getGender,
} from "../../handlers/dictionaryHandler.js";
import GetOneProfile from "../GetProfile/GetOneProfile.js";
import HeaderBack from "../Header/HeaderBack.js";
import InfiniteScroll from "react-infinite-scroll-component";
import DiceLoading from "../DiceLoading.js";
import PreviousMatchReponseBlock from "../PreviousMatchReponseBlock/PreviousMatchReponseBlock.js";

const maxWeeklyUsage = 3;

const PrevMatches = () => {
  const [prevMatch, setPrevMatch] = useState([]);
  const [isPrevMatchesAreaOpen, setIsPrevMatchesAreaOpen] = useState(false);
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [totalPrevMatches, setTotalPrevMatches] = useState(1);
  const [weeklyMatchesUsage, setWeeklyMatchesUsage] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const handleTextReport = (text, pMatchId) => {
    setPrevMatch([
      ...prevMatch.map((prevMatch) => {
        if (prevMatch.match.prevMatchId === pMatchId) {
          return {
            ...prevMatch,
            match: {
              ...prevMatch.match,
              freeText: text,
            },
          };
        } else {
          return prevMatch;
        }
      }),
    ]);
  };

  const handleReportVal = (pMatchId, e) => {
    setPrevMatch([
      ...prevMatch.map((prevMatch) => {
        if (prevMatch.match.prevMatchId === pMatchId) {
          return {
            ...prevMatch,
            match: {
              ...prevMatch.match,
              report: e,
            },
          };
        } else {
          return prevMatch;
        }
      }),
    ]);
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    loadMorePrevMatches(0, true);
  }, []);

  const loadMorePrevMatches = async (offset = 0, isReset = false) => {
    try {
      const limit = 3;
      setIsLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS +
          `/prevMatches_get/${offset}/${limit}`,
        config,
      );
      if (response.data.length === 0) {
        setTotalPrevMatches(0);
        return;
      }

      if (response.data[0].vip !== undefined && response.data[0].vip !== null) {
        localStorage.setItem("VIP", String(response.data[0].vip));
      }

      setWeeklyMatchesUsage(response.data[0].cntMatchWeek);
      setTotalPrevMatches(response.data[0].total);

      const userData = response.data.map((prevMatch) => {
        return {
          match: prevMatch,
          isOpen: false,
          isOtherProfileOpen: false,
        };
      });

      if (isReset) {
        setPrevMatch([...userData]);
      } else {
        setPrevMatch([...prevMatch, ...userData]);
      }
    } catch (error) {
      // probebly user is not authenticated or server is down
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async (prevMatchSave) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/prevMatchReport",
        {
          idMatch: prevMatchSave.prevMatchId,
          report: prevMatchSave.report,
          freeText: prevMatchSave.freeText,
        },
        config,
      );
      if (response.data === true) {
        alertUser("נשמר בהצלחה");
      }
    } catch (error) {
      alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
    }
  };

  const onMatchRenewal = async (matchId) => {
    // remove the match from the list
    // setPrevMatch([
    //   ...prevMatch.filter((match) => match.match.prevMatchId !== matchId),
    // ]);
    // setWeeklyMatchesUsage(weeklyMatchesUsage + 1);
    // setTotalPrevMatches(totalPrevMatches - 1);
  };

  return (
    <form className="double-match-form" id="doublePrevMatch-body">
      <HeaderBack />
      <br />
      <div className="doublematch-body">
        <div id="h1">התאמות קודמות</div>
        <h5 style={{ textAlign: "center" }}>
          ✔️ אפשר לחדש עד 3 התאמות בכל שבוע.
          <br />
          ✔️ לאחר דייט נשמח אם תשאירו משוב 😊
        </h5>
        {/* <div className="messegeMatch">{doubleYes1}</div> */}
        {/* {prevMatch.length > 0 && ( */}
        <InfiniteScroll
          dataLength={prevMatch.length}
          next={() => loadMorePrevMatches(prevMatch.length)}
          hasMore={prevMatch.length < totalPrevMatches}
          loader={<DiceLoading />}
          style={{
            overflow: "unset",
          }}
          scrollableTarget="doublePrevMatch-body"
        >
          {prevMatch.map((pMatch, index) => {
            const weeklyMatchesUsageLeft = Math.max(
              0,
              maxWeeklyUsage - weeklyMatchesUsage,
            );
            const isRelevant = Number(pMatch.match.isRelevant) === 1;

            const showRelevantTitle = index === 0 && isRelevant;

            const showHistoryTitle =
              !isRelevant &&
              (index === 0 ||
                Number(prevMatch[index - 1].match.isRelevant) === 1);
            return (
              <React.Fragment key={pMatch.match.prevMatchId}>
                {showRelevantTitle && (
                  <h3
                    style={{
                      textAlign: "center",
                      margin: "18px 0 10px",
                      fontSize: "18px",
                    }}
                  >
                    💜 התאמות שעדיין יכולות להיות רלוונטיות
                  </h3>
                )}
                {showHistoryTitle && (
                  <div
                    style={{
                      borderTop: "1px solid var(--border-color)",
                      margin: "28px 0 14px",
                      paddingTop: "18px",
                    }}
                  >
                    <h3
                      style={{
                        textAlign: "center",
                        margin: 0,
                        fontSize: "18px",
                      }}
                    >
                      היסטוריית התאמות
                    </h3>
                  </div>
                )}

                <div
                  className="match-card-container"
                  style={{ height: "auto" }}
                >
                  <div
                    className="linePlace"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="rowTitle"
                      style={{
                        minWidth: "unset",
                      }}
                    >
                      {pMatch.match.isEmailSent == "1"
                        ? pMatch.match.prevMatch + ` ❤️ `
                        : pMatch.match.prevMatch}
                    </div>
                    <div
                      className="rowTitle"
                      style={{
                        minWidth: "unset",
                      }}
                    >
                      {" "}
                      <div>
                        {pMatch.match.isEmailSent == "1" ? (
                          <a
                            href={
                              `https://wa.me/972` +
                              pMatch.match.otherCellular +
                              `?text=הי+${
                                pMatch.match.otherName
                              }+מה+נשמע+זה+${getFirstName()}+מדאבל+:)...`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="whatsuplink" />
                          </a>
                        ) : (
                          ""
                        )}
                      </div>{" "}
                    </div>
                  </div>
                  <div className="divider" />

                  <GetOneProfile
                    otherId={pMatch.match.otherId}
                    embedded={true}
                    displayGender={getGender() == "1" ? "2" : "1"}
                  />

                  <div id={`prevMatchReportArea` + pMatch.match.prevMatchId}>
                    {" "}
                    <div className="lbl">
                      {pMatch.match.mySee != "1" ? "לא ראית את ההתאמה." : ""}
                      {pMatch.match.otherSee != "1"
                        ? "הצד השני לא ראה את ההתאמה."
                        : ""}
                      <br />
                      <b>התשובה שלך: </b> {getMyChoice(pMatch.match.myResponse)}
                      <br />
                      <b>תשובת הצד השני: </b>
                      {pMatch.match.myResponse == "4"
                        ? "לא הגבת, אז אי אפשר לראות את התשובה של הצד השני"
                        : getOtherChoice(pMatch.match.otherResponse)}
                    </div>
                    {pMatch.match.isEmailSent == "1" && (
                      <div
                        className="parent-dat"
                        style={{ alignItems: "center" }}
                      >
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 1 ? "active" : ""
                          }`}
                          value={"לא יצרנו קשר :( :("}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 1)
                          }
                        />
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 2 ? " active" : ""
                          }`}
                          value={"בטלפון הבנו שלא מתאים"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 2)
                          }
                        />
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 3 ? " active" : ""
                          }`}
                          value={"יצאנו דייט אחד וזהו"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 3)
                          }
                        />
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 4 ? " active" : ""
                          }`}
                          value={"יצאנו בין 1 ל 4  דייטים"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 4)
                          }
                        />
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 5 ? "active" : ""
                          }`}
                          value={"נכנסנו לקשר ארוך"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 5)
                          }
                        />
                        <input
                          type="button"
                          className={`hatunaReportBtn ${
                            pMatch.match.report === 6 ? "active" : ""
                          }`}
                          value={"חתונה "}
                          // style={{ top: "-6px" }}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 6)
                          }
                        />
                        <input
                          type="button"
                          className={`longTextReportBtn ${
                            pMatch.match.report === 7 ? "active" : ""
                          }`}
                          style={{ top: "0px" }}
                          value={"נפגשנו, התאור שונה מהמציאות"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 7)
                          }
                        />
                        <input
                          type="button"
                          className={`prevMatchReportBtn ${
                            pMatch.match.report === 8 ? "active" : ""
                          }`}
                          value={"הצעה לא קשורה..."}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 8)
                          }
                        />
                        <input
                          type="button"
                          className={`longTextReportBtn ${
                            pMatch.match.report === 9 ? "active" : ""
                          }`}
                          value={"הצעה קשורה אך לא מתאימה"}
                          onClick={(e) =>
                            handleReportVal(pMatch.match.prevMatchId, 9)
                          }
                          style={{ top: "-2px" }}
                        />
                      </div>
                    )}
                    {pMatch.match.isEmailSent == "1" && (
                      <div
                        className="btn-save-report"
                        onClick={() => {
                          onSubmit(pMatch.match);
                        }}
                      >
                        שמירה
                      </div>
                    )}
                    {isErrorMessageDisplayed && (
                      <div className="error-message">
                        <h5>{errorMessage} </h5>
                      </div>
                    )}
                  </div>
                  {pMatch.match.isEmailSent != "1" ? (
                    weeklyMatchesUsageLeft > 0 ? (
                      <PreviousMatchReponseBlock
                        otherName={pMatch.match.otherName}
                        weeklyMatchesUsageLeft={weeklyMatchesUsageLeft}
                        matchId={pMatch.match.prevMatchId}
                        otherId={pMatch.match.otherId}
                        onMatchRenewal={() => {
                          onMatchRenewal(pMatch.match.prevMatchId);
                        }}
                        isOtherActive={pMatch.match.otherActive == "1"}
                      />
                    ) : (
                      <div
                        className="button whiteBackNBorder"
                        id="backBtn"
                        style={{ fontSize: "15px" }}
                      >
                        מִחזרת 3 התאמות השבוע. אפשר בשבוע הבא :)
                      </div>
                    )
                  ) : null}
                </div>
              </React.Fragment>
            );
          })}
        </InfiniteScroll>
        {/* )} */}
        <Link to="/questionnaires" style={{ textDecoration: "none" }}>
          <div
            className="back-link-minimal"
            style={{ display: "block", width: "fit-content", margin: "0 auto" }}
          >
            {" "}
            חזרה
          </div>
        </Link>

        <Link to="/doublematch" style={{ textDecoration: "none" }}>
          <div className="button whiteBackNBorder" id="backBtn">
            {" "}
            <b>→</b>
            מעבר להתאמות
          </div>
        </Link>
      </div>
    </form>
  );
};

export default PrevMatches;
